import type { ApiResponse, PinDto, PinnedEntityType } from '@bower/shared';
import type { HttpClient } from './http-client.types';

/**
 * Per-user sidebar pins API. The backend derives the acting user from auth
 * and scopes every query by (workspaceId, userId) — the client never sends
 * identity. Hydration is ACL-filtered server-side: pins whose entity is
 * restricted/trashed simply don't come back.
 */

export function listPins(http: HttpClient): Promise<ApiResponse<PinDto[]>> {
  return http.get<PinDto[]>('/workspace/pins');
}

export function createPin(
  http: HttpClient,
  payload: { entityType: PinnedEntityType; entityId: string },
): Promise<ApiResponse<{ id: string }>> {
  return http.post<{ id: string }>('/workspace/pins', payload);
}

export function deletePin(http: HttpClient, pinId: string): Promise<ApiResponse<null>> {
  return http.delete<null>(`/workspace/pins/${pinId}`);
}

/**
 * Reorder pins. `orderedIds` is the desired order of the caller's own pin
 * rows; the backend re-keys them via fractional indexing. It is subset-
 * tolerant — a caller that only knows its VISIBLE pins (ghost rows are hidden
 * from the list) may send fewer ids than it owns without a rejection.
 */
export function reorderPins(http: HttpClient, orderedIds: string[]): Promise<ApiResponse<null>> {
  return http.patch<null>('/workspace/pins/reorder', { orderedIds });
}
